import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-[#07294D] text-white py-10">
      <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-4 gap-8">
        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="/" className="hover:underline">
                Home
              </a>
            </li>
            <li>
              <a href="/about/history" className="hover:underline">
                About Us
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Academics
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Admissions
              </a>
            </li>
            <li>
              <a href="/contact" className="hover:underline">
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Popular Links */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Popular Links</h3>
          <ul className="space-y-2">
            <li>
              <a href="/" className="hover:underline">
                Latest News
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Upcoming Events
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Photo Gallery
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                Careers
              </a>
            </li>
            <li>
              <a href="/" className="hover:underline">
                FAQs
              </a>
            </li>
          </ul>
        </div>

        {/* Get in Touch */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
          <p className="text-sm">
            Shree Krishna Academy, Sukhdeo Sumitra path, Bala Bigha road, Teyar
            <br />
            Nawada Bihar (805112)
          </p>
          <p className="mt-4 text-sm">
            Phone:{" "}
            <a href="tel:+919470214758" className="hover:underline">
              +91 9470214758
            </a>
          </p>
          <p className="mt-2 text-sm">
            Email:{" "}
            <a href="mailto:info@skaacademy.org.in" className="hover:underline">
              info@skacademy.org.in
            </a>
          </p>
        </div>

        {/* Follow Us */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
          <div className="flex space-x-4">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-500"
            >
              <FaFacebook size={24} />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-300"
            >
              <FaTwitter size={24} />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-pink-400"
            >
              <FaInstagram size={24} />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-blue-700"
            >
              <FaLinkedin size={24} />
            </a>
          </div>
        </div>
      </div>
      <div className="text-center mt-10 text-sm text-gray-400">
        © 2025 Shree Krishna Academy. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
